import { isAxiosError } from "axios";
import { ApiError } from "@/core/api/types";

const errorStatus = (error: unknown) =>
  error instanceof ApiError
    ? error.status
    : isAxiosError(error)
      ? error.response?.status
      : undefined;

/** Thread-only error copy for the shared PackChat state layout. */
export const getPackChatThreadErrorCopy = (error: unknown) => {
  const status = errorStatus(error);

  if (status === 403) {
    return {
      title: "You don't have access to these messages",
      body: "Ask an owner to give you access to this pay period's PayPacks.",
    };
  }

  if (status === 404) {
    return {
      title: "This thread is no longer here",
      body: "It was removed, or it sits outside the PayPacks you can see.",
    };
  }

  return {};
};

/** Cached conversations remain usable after temporary refresh failures only. */
export const isTemporaryPackChatError = (error: unknown) => {
  if (!error) return false;
  const status = errorStatus(error);
  return !status || status >= 500 || status === 408 || status === 429;
};
